import { createContext } from 'react'

// The context object lives alone, deliberately.
//
// react-refresh/only-export-components: a module exporting both a component
// and a non-component cannot be hot-reloaded reliably, so every edit to it
// forces a full page reload in dev. Keeping the context, the provider and the
// hook in three modules means each exports one kind of thing.
export const AuthContext = createContext()
